export interface ClaudeResponse {
	type?: 'error' | 'message';
	content?: Array<{ type: string; text: string }>;
	error?: ClaudeError;
	usage?: TokenUsage;
}

export interface ClaudeError {
	type: string;
	message: string;
}

export interface TokenUsage {
	input_tokens: number;
	output_tokens: number;
	cache_creation_input_tokens?: number;
	cache_read_input_tokens?: number;
}

export interface ClaudeParsedResponse {
	text: string;
	usage?: TokenUsage | null;
}

export interface AIReportPayload {
	report: string | object;
	type: 'customer_trend' | 'customer_data' | 'inventory_data' | 'item_history';
}

export class ClaudeAPIError extends Error {
	constructor(public error: ClaudeError) {
		super(error.message);
		this.name = 'ClaudeAPIError';
	}
}
